import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        tagsList: [],
    },
    mutations: {
        setTags(state, value) {
            if (typeof (value) == 'number') {
                this.state.tagsList.splice(value, 1)
            } else {
                // if (this.state.tagsList.length < 10) {
                    if (this.state.tagsList.length) {
                        var every = this.state.tagsList.every((ele) => {
                            return ele.name != value.name;
                        })
                        if (every) {
                            this.state.tagsList.push(value)
                        }
                    } else {
                        this.state.tagsList.push(value)
                    }  
                // }
            }
        },
        clearTags() {
            this.state.tagsList = []
        },
    },
    actions: {

    },
    modules: {}
})